import classNames from 'classnames'

const Toggle = (props) => {
    const onToggled = (e) => {
        if (!e.target.value || e.target.value.length === 0) {
            props.update(0)
        } else {
            props.update(parseInt(e.currentTarget.value))
        }
    }

    var toggleButtons = props.styles.map((style, index) => {
        return (
            <p className="control" key={index}>
                <button
                    style={{
                        [props.buttonStyleProp]: style,
                    }}
                    value={index}
                    onClick={onToggled}
                    className={classNames({
                        button: true,
                        'is-active': props.value === index,
                    })}
                >
                    {props.content}
                </button>
            </p>
        )
    })

    return <div className="field has-addons is-toggle">{toggleButtons}</div>
}

export default Toggle
